
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.132 7.484V5.565l1.057.775.861-1.167L8.002 0 .95 5.173l.862 1.167 1.056-.775v1.92L0 9.655v.36C0 14.42 3.589 18 8 18s8-3.581 8-7.984v-.36l-2.868-2.172zm-8.81-2.986L7.999 1.8l3.677 2.698v1.884L8 3.597 4.322 6.382V4.498zm3.677.922l6.537 4.952c-.028.497-.114.99-.256 1.467l-6.282-4.61-6.278 4.605a6.487 6.487 0 01-.256-1.462L7.999 5.42zM2.298 13.21l4.975-3.65v6.944a6.562 6.562 0 01-4.975-3.294zm6.43 3.294V9.564l4.973 3.65a6.542 6.542 0 01-4.974 3.291z","fill":"#B39F5E"}})])
          )
        }
      }
    